import { useState } from "react";

import { CustomerCareContactModal } from "components/customer-care-contact-modal";
import { RegularContentLoader } from "components/loader";
import { usePaperlessSettingsDataQuery } from "gql/__generated__/hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";
import { authUser } from "utils";

import PaperlessItem from "./paperless-item";

export const Paperless = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  const { loading, data } = usePaperlessSettingsDataQuery({
    variables: { email: authUser()?.email ?? "" },
  });

  if (loading) {
    return <RegularContentLoader />;
  }
  const { userPolicies } = data ?? {};

  const policyItems = userPolicies?.map((policy) => (
    <PaperlessItem key={policy.policyId} policy={policy} />
  ));

  return (
    <>
      <SettingsPanelLayout title="Paperless" policyItems={policyItems} />
      <CustomerCareContactModal
        description="We can assist with any questions about billing or your SageSure account."
        handleClose={() => {
          setShowContactModal(false);
        }}
        show={showContactModal}
      />
    </>
  );
};
